import React, { useState } from 'react';

export const SearchContext = React.createContext<{
  search: string | undefined;
  setSearch: React.Dispatch<React.SetStateAction<string | undefined>>;
}>({ search: undefined, setSearch: () => {} });

export function SearchProvider({ children }: { children: JSX.Element }): JSX.Element {
  const [search, setSearch] = useState<string>();

  return <SearchContext.Provider value={{ search, setSearch }}>{children}</SearchContext.Provider>;
}
